import React, { Component } from "react";

import {
  CBadge,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CHeaderNavItem,
  CHeaderNavLink,
  CImg,
  CTooltip
} from "@coreui/react";
import { CircleHelp } from "lucide-react";
import {
  RiChat3Fill,
  RiErrorWarningFill,
  RiNotification3Fill
} from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { withRouter } from "react-router-dom";
import { Button } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../actions/baseActions";
import { setShowChat } from "../actions/chatActions";
import { readUnreadMessage } from "../actions/menuActions";
import { hideHelpdesk, showHelpdesk } from "../actions/noteActions";
import profile from "../assets/imgs/profileEmpty.jpg";
import XpBadge from "../components/Gamification/XpBadge";
import Loading from "../components/Loading";
import ModalComponent from "../components/Modal/ModalGroupRegion";
import StreakBadge from "../components/Streaks/StreakBadge";
import { abrirTour } from "../components/Tour/barramento";
import { temTour } from "../components/Tour/roteiros";
import URL from "../config/api";
import axios from "../config/axios";
import { store } from "../store/store"; // ✅ Sem extensão

class HeaderMenu extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      modal: false,
      // routeCounter: 0,
      // routes: [],
      messages: [],
      // region: [],
      // helpdesk: false,
      // base64image: null,
      isAlagoas: false
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.readUnread = this.readUnread.bind(this);
    this.handleChildUnmount = this.handleChildUnmount.bind(this);
    this.fields = {};
    this.timer = null;
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.general.active_roles || {};
    const atual = this.props.general.active_roles || {};

    // O grupo também conta: o acesso às telas é por perfil NO grupo
    // (access_groups_roles_menus).
    if (
      (prev.role_id !== atual.role_id || prev.group_id !== atual.group_id) &&
      typeof atual.role_id !== "undefined"
    ) {
      this.fetchProtectedRoutes(atual.role_id, atual.group_id);
    }
  }

  fetchProtectedRoutes = async (roleId, groupId) => {
    try {
      const response = await axios.get(
        `${URL.api}access/role/protectedRoute/${roleId}`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` },
          params: { group_id: groupId || undefined }
        }
      );

      if (response.data.success) {
        store.dispatch({
          type: "USER_ROUTES",
          payload: response.data.data
        });
      }
    } catch (error) {
      toastr.error("Erro ao buscar rotas protegidas:", error);
    }
  };

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  toggle() {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  toggleModal() {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      modal: !this.state.modal
    });
  }

  readUnread(e) {
    let { id } = e.target;
    let index = "";
    this.state.messages.map((message, idx) => {
      if (parseInt(message.id) === parseInt(id)) {
        index = idx;
      }
      this.props.readUnreadMessage(message.id);
      return index;
    });

    let messages = [];

    this.state.messages.forEach(message => {
      messages.push(message);
    });

    for (let i = 0; i < messages.length; i++) {
      if (i === index) {
        messages[i].read = !messages[i].read;
      }
    }

    this.setState({
      messages
    });
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "JAN",
      "FEV",
      "MAR",
      "ABR",
      "MAI",
      "JUN",
      "JUL",
      "AGO",
      "SET",
      "OUT",
      "NOV",
      "DEZ"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} ${months[dt.getMonth()]} ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} ${months[dt.getMonth()]}`;
  }

  handleNotifications() {
    axios
      .post(
        `${URL.api}communication/notice/listNotifications`,
        { user_id: this.props.user.user.id },
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(async resp => {
        let messages = await Promise.all(
          resp.data.data.map(async message => {
            let link = "#";

            const foundMessage = this.state.messages.find(
              item => item.id === message.id
            );

            if (foundMessage) {
              link = foundMessage.link;
            } else if (message.room_id) {
              link = await this.getLink(message.room_id);
            }

            link = `/notice/details/${message.id}`;

            return {
              id: message.id,
              user: message.user_name,
              photo: message.user_photo,
              dateWeek: this.friendlyDate(message.created_at),
              link,
              read: message.viewed_by !== null,
              message: message.title
            };
          })
        );
        this.setState({ messages });
      });
  }

  async getLink(id) {
    let verify = true;
    /* await axios
      .get(`${URL.api}community/room/singleView/${id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.data) verify = resp.data.data.room.class;
      }); */
    if (verify) {
      return `/classroom/${id}`;
    }
    return `/room/${id}`;
  }

  viewNotifications() {
    const messages =
      this.state.messages &&
      this.state.messages.filter(item => item.read === false);

    if (messages && messages.length > 0) {
      axios
        .post(
          `${URL.api}communication/notice/viewNotifications`,
          { notices: messages.map(item => item.id) },
          { headers: { authorization: `Bearer ${this.props.user.token}` } }
        )
        .then(resp => {});
    }
  }

  handleChildUnmount() {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ renderChild: false });
  }

  showChat() {
    this.props.setShowChat(true);
  }

  getExtra() {
    const role = this.props.general.active_roles;

    if (role.type === "G") {
      if (role.school_id) return " (Escola)";
      if (role.region_id) return " (Região)";
      if (role.group_id) return " (Grupo)";
    } else if (role.type === "U") {
      if (role.school_id) return " (Escola)";
      if (role.region_id) return " (Região)";
    } else if (role.type === "R") {
      if (role.school_id) return " (Escola)";
    }

    return "";
  }

  render() {
    const { token } = this.props.user;
    // Único ponto de entrada do tour: ele é sob demanda, sem gatilho automático
    // e sem "já viu" guardado. Fica no header, e não no menu de Ajuda, porque o
    // menu vem do backend e varia por cliente — o header existe em toda tela.
    //
    // A MESMA função que o orquestrador usa para escolher o roteiro decide se o
    // ícone aparece, para não existir gatilho que abre um tour vazio.
    const mostrarTour = temTour(this.props.general.active_roles?.role_id);

    return (
      <React.Fragment>
        {this.state.loading ? (
          <Loading color="123abc" loading top="4" left="16" />
        ) : (
          <React.Fragment>
            {this.state.modal && (
              <ModalComponent
                toggleModal={this.toggleModal}
                modalState={this.state.modal}
                title="Escolha sua rede"
                className="educandus"
              />
            )}
            {mostrarTour && (
              <CTooltip content="Conhecer a plataforma">
                <CHeaderNavItem className="c-header-nav-item mx-2">
                  <CHeaderNavLink
                    to="#"
                    onClick={abrirTour}
                    aria-label="Conhecer a plataforma"
                  >
                    <CircleHelp className="header-icon" />
                  </CHeaderNavLink>
                </CHeaderNavItem>
              </CTooltip>
            )}
            {this.state.isAlagoas === false && (
              <>
                <CTooltip content="Criar solicitação">
                  <CHeaderNavItem className="c-header-nav-item mx-2">
                    <CHeaderNavLink
                      to="#"
                      onClick={() => this.props.showHelpdesk()}
                    >
                      <RiErrorWarningFill className="header-icon" />
                    </CHeaderNavLink>
                  </CHeaderNavItem>
                </CTooltip>
              </>
            )}
            <CTooltip content="Perguntas frequentes">
              <CHeaderNavItem className="c-header-nav-item mx-2">
                <CHeaderNavLink
                  to="#"
                  onClick={() => this.showChat()}
                  aria-label="Perguntas frequentes"
                >
                  <RiChat3Fill className="header-icon" />
                </CHeaderNavLink>
              </CHeaderNavItem>
            </CTooltip>
            <CHeaderNavItem className="c-header-nav-item mx-2 hide-on-mobile-576">
              <Button
                color="info"
                size="sm"
                onClick={() => this.props.showHelpdesk()}
              >
                Abrir chamado
              </Button>
            </CHeaderNavItem>
            <StreakBadge />
            <XpBadge />
            <CTooltip content="Notificações">
              <CDropdown inNav className="c-header-nav-item mx-2">
                <CDropdownToggle
                  className="c-header-nav-link"
                  caret={false}
                  onClick={() => this.viewNotifications()}
                >
                  <RiNotification3Fill
                    className={
                      this.state.isAlagoas
                        ? "color-button header-icon"
                        : "header-icon"
                    }
                  />
                  <CBadge
                    shape="pill"
                    color="danger"
                    className={
                      this.state.messages.find(item => item.read === false)
                        ? "teste "
                        : "d-none teste "
                    }
                  >
                    !
                  </CBadge>
                </CDropdownToggle>
                <CDropdownMenu
                  placement="bottom-end"
                  className="pt-0"
                  style={{ minWidth: 300 }}
                >
                  <CDropdownItem
                    header
                    tag="div"
                    color="light"
                    className="border-0 d-flex justify-content-center"
                  >
                    <strong>Últimas notificações</strong>
                  </CDropdownItem>
                  {this.state.messages.length > 0 ? (
                    this.state.messages.map((message, idx) => (
                      <CDropdownItem key={idx} href={message.link}>
                        <div className="message w-100">
                          <div className="pt-3 mr-3 float-left">
                            <div className="c-avatar">
                              <CImg
                                src={
                                  message.photo
                                    ? URL.img + message.photo
                                    : profile
                                }
                                className="c-avatar-img"
                                alt={message.user}
                              />
                              {!message.read && (
                                <span className="c-avatar-status bg-danger"></span>
                              )}
                            </div>
                          </div>
                          <div>
                            <small className="text-muted">
                              {message.read ? "Lido" : "Não lido"}
                            </small>
                            <small className="text-muted float-right mt-1">
                              {message.dateWeek}
                            </small>
                          </div>
                          <div className="text-truncate font-weight-bold">
                            {message.user}
                          </div>
                          <div className="small text-muted text-truncate">
                            {message.message}
                          </div>
                        </div>
                      </CDropdownItem>
                    ))
                  ) : (
                    <div className="d-flex align-items-center justify-content-center text-muted small p-2 mt-2 w-100">
                      Nenhuma notificação
                    </div>
                  )}
                  <CDropdownItem divider />
                  <CDropdownItem
                    className="border-0 d-flex justify-content-center"
                    to="/notice/me"
                  >
                    <strong>Ver mais</strong>
                  </CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </CTooltip>
            <CDropdown inNav className="c-header-nav-item mx-2">
              <CDropdownToggle className="c-header-nav-link" caret={false}>
                <div className="c-avatar">
                  <img
                    src={
                      URL.img +
                      (this.props.user.user.photo ||
                        "uploads/users/profileEmpty.jpg")
                    }
                    className="c-avatar-img"
                    alt={this.props.user.user.name}
                  />
                </div>
              </CDropdownToggle>
              <CDropdownMenu placement="bottom-end" className="pt-0">
                <CDropdownItem
                  header
                  tag="div"
                  color="light"
                  className="border-0"
                >
                  <strong>Conta</strong>
                </CDropdownItem>
                <CDropdownItem to={`/profile/${this.props.user.user.id}`}>
                  <i className="fa fa-user"></i> {this.props.user.user.name}
                </CDropdownItem>
                <CDropdownItem
                  header
                  tag="div"
                  color="light"
                  className="border-0"
                >
                  <strong>Unidade</strong>
                  <span
                    className="not-link float-right cursor"
                    onClick={this.toggleModal}
                  >
                    <i className="fa fa-gear"></i>
                  </span>
                </CDropdownItem>
                {this.props.general.active_roles.group_name && (
                  <CDropdownItem disabled>
                    <i className="fa fa-wrench"></i>{" "}
                    {this.props.general.active_roles.group_name}
                  </CDropdownItem>
                )}
                {this.props.general.active_roles.region_name && (
                  <CDropdownItem disabled>
                    <i className="fa fa-globe"></i>{" "}
                    {this.props.general.active_roles.region_name}
                  </CDropdownItem>
                )}
                {this.props.general.active_roles.school_name && (
                  <CDropdownItem disabled>
                    <i className="fa fa-institution"></i>{" "}
                    {this.props.general.active_roles.school_name}
                  </CDropdownItem>
                )}
                {this.props.general.active_roles.role_name && (
                  <CDropdownItem disabled>
                    <i className="fa fa-id-card"></i>{" "}
                    {this.props.general.active_roles.role_name +
                      this.getExtra()}
                  </CDropdownItem>
                )}
                <CDropdownItem divider />
                <CDropdownItem
                  onClick={() => {
                    this.props.logout(token);
                    this.props.history.push("/logout");
                  }}
                >
                  <i className="fa fa-lock"></i> Sair
                </CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  form: state.form,
  general: state.general,
  note: state.note,
  chat: state.chat
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      readUnreadMessage,
      setShowChat,
      hideHelpdesk,
      showHelpdesk
    },
    dispatch
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HeaderMenu)
);
